var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "container",
      attrs: { id: "AddIntegration" },
    },
    [
      _c("div", { staticClass: "header" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("message.addIntegration")))]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              "justify-content": "end",
              "text-align": "center",
              "align-items": "center",
            },
          },
          [
            _vm.bar !== 0
              ? _c("a-icon", {
                  staticStyle: { "font-size": "21px" },
                  attrs: { type: "close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close-menu", 0)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("AddIntegrationItem", {
            attrs: {
              "story-id": _vm.storyId,
              itemText: _vm.$t("chatbotv2.chatWidget"),
              "integration-type": "web",
            },
            on: {
              "connect-event": _vm.supsisWebIntegration,
              "remove-story": _vm.removeWebIntegration,
            },
          }),
          _vm._v(" "),
          _c("AddIntegrationItem", {
            attrs: {
              "story-id": _vm.storyId,
              itemText: _vm.$t("message.distWhatsapp"),
              "integration-type": "whatsapp",
            },
          }),
          _vm._v(" "),
          _c("AddIntegrationItem", {
            attrs: {
              "story-id": _vm.storyId,
              itemText: "Whatsapp Business API",
              "integration-type": "whatsapp-business-api",
            },
          }),
          _vm._v(" "),
          _c("AddIntegrationItem", {
            attrs: {
              "story-id": _vm.storyId,
              itemText: "Instagram",
              "integration-type": "instagram",
            },
          }),
          _vm._v(" "),
          _c("AddIntegrationItem", {
            attrs: {
              "story-id": _vm.storyId,
              itemText: "Messenger",
              "integration-type": "messenger",
            },
          }),
          _vm._v(" "),
          _c("AddIntegrationItem", {
            attrs: {
              "story-id": _vm.storyId,
              itemText: "Telegram",
              "integration-type": "telegram",
            },
            on: {
              "connect-event": _vm.telegramIntegration,
              "remove-story": _vm.removeTelegramIntegration,
            },
          }),
          _vm._v(" "),
          _c("AddIntegrationItem", {
            attrs: {
              "story-id": _vm.storyId,
              itemText: "Trendyol",
              "integration-type": "trendyol",
            },
            on: {
              "connect-event": _vm.telegramIntegration,
              "remove-story": _vm.removeTelegramIntegration,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }